import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CustomDatePipe } from './custom-date.pipe';
import { SafeHtmlPipe } from './safe-html.pipe';
import { RutFormatPipe } from './rut-format.pipe';
import { TruncatePipe } from './truncate.pipe';
import { ExtraerNombreDocPipe } from './extraer-nombre-doc.pipe';

@NgModule({
  declarations: [],
  imports: [CommonModule, CustomDatePipe, SafeHtmlPipe, RutFormatPipe, TruncatePipe,ExtraerNombreDocPipe],
  exports: [CustomDatePipe, SafeHtmlPipe, RutFormatPipe, TruncatePipe,ExtraerNombreDocPipe],
})
export class PipesModule {}
